<template lang="pug">
  .component-backoffice-category-list.row.column
    .row
      .column.small-12.large-6.category(v-for="(type, index) in types" :key="`VT${type.id}-${index}`" v-on:click="setSearch(index)", :class="{ active: activeIndex === index}")
        .inner-content.card.text-center
          .row.text-center
            .column.text-left
              h2 {{ type.name }}
            .column.text-right
              pre VT{{type.id}}
          .row.text-center
            .column.text-right
              i.fa.fa-trash.fa-2x(v-if="activeIndex === index", @click="deleteType")
          .row.text-center
            .column.text-left
              p {{type.description}}
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "../../maggieHelper";

  export default {
    name: "VehicleTypesList",
    components: {
    },
    data: function () {
      return {
        types: [],
        activeIndex: null,
      }
    },
    created() {
      KeplerBackofficeSdk.vehicleTypes.list.all((data) => {
        this.types = data;
        this.setSearch(0)
      })
    },
    methods: {
      setSearch(index) {
        this.activeIndex = index
      },
      deleteType() {
        this.$confirm('Are you sure?', 'Do you really want to delete this type?', () => {
          KeplerBackofficeSdk.vehicleTypes.select(this.types[this.activeIndex].id).remove((data) => {
            MaggieHelper.notification('type',data.result_code)
            window.location.reload()
          })
        })
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleTypesList.vue?dd8048c6